<template>
    <div class="create-account">
        <div class="title">{{params.title}}</div>
        <div class="center-block">
            <el-row :gutter="20">
                <el-col v-for="(item,index) in params.datas" :key="index" :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
                    <div class="div1">
                        <div class="xuehua-and-btn">
                            <div class="icon-xuehua">
                                <i class="icon1-at-xuehua"></i>
                            </div>
                            <div class="icon-dian">
                                <el-dropdown @command="handleClick">
                                    <span class="icon-dian1 el-dropdown-link">
                                        <i class="el-icon-more"></i>
                                    </span>
                                    <el-dropdown-menu slot="dropdown">
                                        <el-dropdown-item :key="i" v-for="(a,i) in params.buttons" :command="getBtnInfo(item,a.value)">{{a.name}}</el-dropdown-item>
                                    </el-dropdown-menu>
                                </el-dropdown>
                            </div>
                        </div>
                        <div class="account-number">{{item.id}}</div>
                        <div class="bank-info-link" v-for="(obj,key) in item.info" :key="key">
                            <span class="font-item">{{key}}</span>
                            <span class="content-right">{{obj}}</span>
                        </div>
                    </div>
                </el-col>
                <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
                    <div class="div1" @click="createAccount">
                        <div class="radis-line">
                            <div class="title-add">ADD</div>
                            <div class="title-account">ACCOUNT</div>
                            <div class="add-icon">
                                <i class="el-icon-plus" />
                            </div>
                        </div>
                    </div>
                </el-col>
            </el-row>
        </div>
        <bDialog :dialogVisible.sync="dialogVisible" :params=params :component="params.component" :contiune="contiune" :showClose="showClose"></bDialog>
    </div>
</template>

<script>
    export default {
        props: ['params'],
        data() {
            return {
                dialogVisible: false,
                contiune: true,
                showClose: true
            }
        },
        methods: {
            getBtnInfo(item, command) {
                return {
                    item: item,
                    command: command
                }
            },
            createAccount() {
                this.dialogVisible = true
                console.log('data:', this.params)
            },
            handleClick(command) {
                this.$emit('onClick', command)
            }
        }
    }
</script>

<style lang="scss" scoped>
    .create-account {
        .title {
            margin: 1rem 2rem;
            line-height: 40px;
            padding-bottom: 5px;
            border-bottom: 3px solid #e2e2e2;
        }

        .div1,
        .div2,
        .div3,
        .div4 {
            height: 250px;
            // border: 1px solid #000;
        }

        .div1 {
            padding: 20px 20px;
            margin: 10px 0;
            -webkit-box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);

            .radis-line {
                border: 3px dotted #f6c037;
                position: relative;
                height: 100%;
                border-radius: 6px;
                font-weight: bold;
                cursor: pointer;

                .title-add {
                    position: absolute;
                    bottom: 60px;
                    left: 20px;
                    font-size: 24px;
                    color: #f6c037;
                }

                .title-account {
                    position: absolute;
                    bottom: 20px;
                    left: 20px;
                    font-size: 24px;
                    color: #f6c037;
                }

                .add-icon {
                    position: absolute;
                    top: -15px;
                    right: -15px;
                    width: 40px;
                    height: 40px;
                    font-size: 24px;
                    line-height: 40px;
                    font-weight: bold;
                    text-align: center;
                    color: #f6c037;
                    z-index: 1;
                    background-color: #fff;
                }
            }

            .xuehua-and-btn {
                clear: none;
                height: 30px;

                .icon-xuehua {
                    float: left;
                    font-weight: bold;
                    font-size: 24px;
                }

                .icon-dian1 {
                    color: #f6c037;
                    font-weight: bold;
                    font-size: 24px;
                }

                .icon-dian {
                    float: right;
                    outline: none;
                }
            }

            .account-number {
                border-bottom: 1px solid #ccc;
                line-height: 40px;
            }

            .bank-info-link {
                width: 100%;
                height: 42px;
                clear: none;
                border-bottom: 1px solid #ccc;

                .font-item {
                    line-height: 40px;

                    float: left;
                    font-family: "Muli-SemiBold";
                    font-size: 12px;
                    color: #ccc;
                }

                .content-right {
                    font-size: 14px;
                    line-height: 40px;
                    color: #000;
                    float: right;
                }
            }
        }

        .center-block {
            margin: 1rem 2rem;
        }
    }
</style>
